import apiClient from './apiClient';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';
const authClient = axios.create({
  baseURL: `${API_URL}/creator-portal`,
  withCredentials: true,
});

export const getTwitterAuthUrl = () => `${API_URL}/creator-portal/auth/twitter`;
export const getDiscordLoginUrl = () => `${API_URL}/creator-portal/auth/discord/login`;
export const initTwitterReplacement = () => apiClient.post('/auth/twitter/replace/init');

export const getTwitterCallbackUrl = (search = '') => (
  `${API_URL}/creator-portal/auth/twitter/callback${search || ''}`
);

export const getTwitterAuthSession = () => authClient.get('/auth/twitter', {
  params: { format: 'json' }
});

export const verifyToken = () => apiClient.get('/auth/verify');

export const exchangeAuthCode = (code) => authClient.post('/auth/exchange', { code });

export const initDiscordConnect = () => apiClient.post('/auth/discord/init');

export const initTelegramConnect = () => apiClient.post('/auth/telegram/init');

export const logoutSession = () => authClient.post('/auth/logout');
